import keyMirror from 'keymirror';

const types = keyMirror({
	RESET_USER_LIST: null,
	APPEND_USER_LIST: null,
	UPDATE_USER_LIST: null,
	SWITCH_SELECTED_USER: null,
	SWITCH_YEAR: null,
	SWITCH_MONTH: null,
	UPDATE_DAILY_SALARY: null,
	UPDATE_SALARY_ADJUST: null,
	UPDATE_SALARY_ADJUST_DETAIL: null,
  REMOVE_SALARY_ADJUST: null,
	UPDATE_SHIFT_RECORD: null,
  CONFIRM_RECORD: null,
  REFRESH_POSITION_LIST: null,
	UPDATE_POSITION_NAME: null,
	UPDATE_POSITION_TYPE: null,
  DELETE_POSITION: null,
  ADD_POSITION: null,
	START_LOADING_USER_DATA: null,
	FINISH_LOADING_USER_DATA: null,
});

export default types;



// WEBPACK FOOTER //
// ./src/constants/UserConstants.js